import React, { FC } from 'react'
import { mainColors } from '../../../assets/colors'

interface Props {
  cellContent: string;
}

const getColor = (status: string): any => {
  switch (status) {
    case 'Pending':
    case 'Submitted for Review':
    case 'Submitted for Approval':
      return { backgroundColor: mainColors.ratingYellow, color: 'black', fontWeight: '500' }
    case 'Approved':
    case 'Completed':
      return { backgroundColor: mainColors.successGreen, color: 'white', fontWeight: '500' }
    case 'N/A':
      return { backgroundColor: 'white', color: 'black', fontWeight: '500' }
    default:
      return { backgroundColor: mainColors.warningBlue, color: 'white', fontWeight: '500' }
  }
}

const Status: FC<Props> = ({ cellContent }: Props) => {
  const width = 200
  const { backgroundColor, color, fontWeight } = getColor(cellContent)

  return (
    <span style={{ display: 'inline-block', backgroundColor, color, fontWeight, width, textAlign: 'center', marginTop: 5, textTransform: 'uppercase', borderRadius: '0.25rem' }}>
      {cellContent}
    </span>
  )
}

export default Status